import { render, staticRenderFns } from "./citizenship.vue?vue&type=template&id=a5c84454&"
import script from "./citizenship.vue?vue&type=script&lang=ts&"
export * from "./citizenship.vue?vue&type=script&lang=ts&"
import style0 from "./citizenship.vue?vue&type=style&index=0&id=a5c84454&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports